module.exports = __webpack_public_path__ + "static/media/WI5@2x.624ed168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/WI/WI5@2x.png
// module id = 745
// module chunks = 0